export enum HomePageGridAreaNames {
  TARGET_GROUP = 'TARGET_GROUP',
  SPOTLIGHT = 'SPOTLIGHT',
  BELOW_SPOTLIGHT = 'BELOW_SPOTLIGHT',
}
